import { Typography, useAudioTime } from "@aircall/tractor";

import { formatTime } from "@/helpers/time/time.helpers";

export function PlayerCurrentTime() {
  const { currentTime } = useAudioTime();

  return (
    <Typography
      variant="bodyMediumS"
      color="text-placeholder"
      textAlign="end"
      userSelect="none"
      data-test="player-current-time-display"
    >
      {formatTime(currentTime)}
    </Typography>
  );
}
